document.addEventListener("DOMContentLoaded", function() {
    const carousel = document.getElementById('product-carousel');
    const prevButton = document.getElementById('carousel-prev');
    const nextButton = document.getElementById('carousel-next');

    if (!carousel) return; // Stop if carousel is not found

    let index = 0;
    const totalProducts = carousel.children.length;
    const maxIndex = totalProducts > 5 ? totalProducts - 5 : 0; // Update based on your needs

    function updateCarousel() {
        carousel.style.transform = `translateX(-${20 * index}%)`;
    }

    prevButton.addEventListener('click', function() {
        index = (index > 0) ? index - 1 : maxIndex;
        updateCarousel();
    });

    nextButton.addEventListener('click', function() {
        index = (index < maxIndex) ? index + 1 : 0;
        updateCarousel();
    });

    setInterval(() => {
        if (totalProducts <= 5) return; // Stop if not enough products
        index = (index < maxIndex) ? index + 1 : 0;
        updateCarousel();
    }, 3000); // Rotate every 3 seconds
});
